import { useCompanyRelativePath } from 'ogp/hooks';
import { useGetOGPUserInfo } from 'ogp/hooks/queryHooks/users/use-get-ogp-user-info';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { routes } from 'Routes';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { hasOgpAccessOrHqCompanyAdmin } from 'shared/utils/policy-controller';
import { AgreementCard } from './agreement-card';

export const CustomerCard = ({
  serviceAgreement,
}: {
  serviceAgreement: ServiceAgreementsResponse[number];
}) => {
  const generatePath = useCompanyRelativePath();
  const route = useCustomerDetailRoute();

  return (
    <AgreementCard
      id={serviceAgreement.id}
      title={serviceAgreement.borrowerServiceAgreementParty.name}
      to={generatePath(route, { id: serviceAgreement.id })}
    />
  );
};

const useCustomerDetailRoute = () => {
  const { allowClientManagement } = useFeatureFlagContext();
  const userQuery = useGetOGPUserInfo();
  const { policyGroup, roles } = routes.CollegialLendingCustomerDetail;
  const canViewCompanyDetail =
    !!userQuery.data && hasOgpAccessOrHqCompanyAdmin(policyGroup, userQuery.data.userInfo, roles);

  if (allowClientManagement && canViewCompanyDetail) {
    return routes.CollegialLendingCustomerDetail;
  }

  return routes.ServiceAgreementDetail;
};
